'use client'
import React, { useState } from 'react'
import MyImage from '../../myImage'
import PlayerImage from '@/assets/images/placeholder/player.svg'
import { getImgURL, getSlugUrl } from '@/shared/utils'
import { roles } from '@/shared/constants'
import CustomLink from '../../customLink'
import CommonNav from '../../commonNav'

function TopPicks({ data }: any) {
  const [currentActiveTab, setCurrentActiveTab] = useState('captain')

  const CardComponent = ({ playerData }: { playerData: any }) => (
    <div
      className={` bg-headersActive dark:border-0 border border-tabBorder rounded-xl px-4 py-2 md:p-4 ${
        playerData?.sDescription ? '' : ''
      }`}
    >
      <div className='pb-3 md:pb-4 flex items-center justify-between border-b border-borderStroke'>
        <div className='flex items-center gap-3 md:gap-4'>
          <MyImage
            src={playerData?.oPlayerFan?.oPlayer?.oImg?.sUrl ? getImgURL(playerData?.oPlayerFan?.oPlayer?.oImg?.sUrl) : PlayerImage}
            alt='player'
            height={60}
            width={60}
            className=' w-12 h-12 md:w-[60px] md:h-[60px] rounded-full'
          />
          <div className='flex flex-col justify-center'>
            <CustomLink
              href={playerData?.oPlayerFan?.oPlayer?.oSeo?.sSlug ? getSlugUrl('/' + playerData?.oPlayerFan?.oPlayer?.oSeo?.sSlug) : ''}
            >
              <span className='text-sm md:text-base text-textOffWhite mb-1 font-medium'>{playerData?.oPlayerFan?.oPlayer?.sFullName}</span>
            </CustomLink>
            <span className='text-t-secondary flex items-center gap-2'>
              {(playerData?.eType === 'c' || playerData?.eType === 'v') && (
                <span className='text-center text-sm dark:text-textOffWhite text-white flex items-center justify-center bg-winBg rounded size-4 md:size-[18px] '>
                  {playerData?.eType === 'c' ? 'C' : playerData?.eType === 'v' ? 'VC' : null}
                </span>
              )}
              <div className='text-textDselected text-xs md:text-sm flex items-center gap-2'>
                <span>{playerData?.oPlayerFan?.oTeam?.sAbbr}</span>
                <div className='bg-[#353535] rounded-full h-1 w-1'></div>
                <span>{roles[playerData?.oPlayerFan?.oPlayer?.sPlayingRole]}</span>
              </div>
            </span>
          </div>
        </div>
        <div className='text-ScheduledBG text-2xl font-bold md:text-32px'>{playerData?.oPlayerFan?.nRating}</div>
      </div>

      <div className='pt-4'>
        <span className='text-textDselected text-xs font-normal md:text-sm line-clamp-3'>{playerData?.sDescription}</span>
      </div>
    </div>
  )

  const dataMap: any = {
    captain: 'aCVCFan',
    top: 'aTopicPicksFan',
    budget: 'aBudgetPicksFan'
  }

  const tabs = [
    { navItem: 'Captains', value: 'captain' },
    { navItem: 'Top Players', value: 'top' },
    { navItem: 'Best in Budget', value: 'budget' }
  ]
  return (
    <>
        <h4 className='text-sm md:text-lg font-medium md:font-bold md:mt-8 mb-4 md:mb-6 text-textOffWhite '>Player Picks</h4>
      <div className=' block '>
        <div className='text-center flex mb-4 cursor-pointer items-center rounded-xl p-0'>

          <CommonNav
            items={tabs}
            variant='pills'
            asButton
            className='!mb-0 !font-bold justify-start !text-nowrap'
            tabClassName='!text-xs !font-medium h-9 !leading-3'
            onTabChange={(e: any) => setCurrentActiveTab(e?.value)}
            isActive={(item : any) => item?.value === currentActiveTab}
          />
        </div>
        <div className='grid md:grid-cols-2 gap-3 md:gap-4'>
          {data && data[dataMap[currentActiveTab]]?.map((p: any, i: number) => <CardComponent key={i} playerData={p} />)}
        </div>
      </div>
    </>
  )
}

export default TopPicks
